import React from "react";
import "./HomePage.css";
import { ProjectStatusCardsSection } from "./components/ProjectStatusCardsSection";
import { MapSection } from "./components/MapSection";
import { ProjectContentSection } from "./components/ProjectContentSection";
import { PaginationSection } from "./components/PaginationSection";
import { FilterDrawer } from "./components/FilterDrawer";
import { HomePageProvider, useHomePageContext } from "./context/HomePageContext";

/**
 * HomePageContent component - Clean, focused component with zero props
 * Following Clean Code principle: Single responsibility - only handles UI layout
 */
const HomePageContent: React.FC = () => {
  const { uiState, actions } = useHomePageContext();

  return (
    <div className="relative p-6">
      <div className="flex w-full flex-col">
        <ProjectStatusCardsSection />

        <MapSection />

        <FilterDrawer isOpen={uiState.isFilterDrawerOpen} onClose={actions.closeFilterDrawer} />

        <ProjectContentSection />

        <PaginationSection />
      </div>
    </div>
  );
};

/**
 * HomePage component - Main dashboard for project management
 * Following Clean Code principle: Separation of concerns - provider wrapper
 */
function HomePage() {
  return (
    <HomePageProvider>
      <HomePageContent />
    </HomePageProvider>
  );
}

export default HomePage;
